import ReactDOM from "react-dom/client"
import Provider from "./Provider"
import Router from "./Router"
import Container from "./Container"
import "./styles/styles.css"
// import "spt-react/dist/index.css"
import * as Sentry from "@sentry/react"

Sentry.init({
  dsn: "https://8824d8ec8d3c817be9f5748a03a4d537@o4505997961527296.ingest.sentry.io/4506026023845888",
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      // tracePropagationTargets: ["localhost", /^https:\/\/editor\.selfpublishingtitans\.com/],
    }),
    new Sentry.Replay(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

ReactDOM.createRoot(document.getElementById("root")!).render(
  <>
    <script src="https://accounts.google.com/gsi/client" async defer />

    <Provider>
      <Container>
        <Router />
      </Container>
    </Provider>
  </>
)
